module.exports = __webpack_public_path__ + "static/img/6zhineng.59ee8f2b.jpg";